// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Engage / OneLink — uses dashboard-box theme from App.css + Segments patterns */


.engage-page {
  padding: 20px 24px;
  min-height: 100vh;
}

.engage-breadcrumb {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.engage-breadcrumb .separator {
  margin: 0 8px;
}

.engage-breadcrumb a {
  color: #4c5fd5;
  text-decoration: none;
}

.engage-breadcrumb a:hover {
  text-decoration: underline;
}

.engage-page-title {
  font-size: 28px;
  font-weight: 600;
  margin: 4px 0 16px;
  color: #1a1a1a;
}


.engage-template-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.engage-template-bar label {
  font-weight: 600;
  margin: 0;
  color: #333;
}

.engage-template-select {
  min-width: 160px;
  padding: 8px 12px;
  border: 1px solid #d8dee6;
  border-radius: 8px;
}

.engage-template-meta {
  font-size: 13px;
  color: #666;
}

/* Create / edit link modal */
.engage-create-modal .modal-body {
  padding-top: 8px;
  max-height: min(70vh, 640px);
  overflow-y: auto;
}

.engage-modal-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
}

.engage-modal-step-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  color: #666;
  background: #f4f6f9;
  border: 1px solid #e8ecf1;
}

.engage-modal-step-pill.active {
  color: #4c5fd5;
  border-color: #4c5fd5;
  background: #eef2ff;
  font-weight: 600;
}

.engage-modal-step-pill.done {
  color: #1b7a3f;
  background: #e6f7ee;
  border-color: #b8e6c8;
}

.engage-modal-step-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background: #fff;
}

.engage-modal-layout {
  display: grid;
  grid-template-columns: 1fr 240px;
  gap: 20px;
  align-items: start;
  min-width: 0;
}

.engage-modal-form {
  min-width: 0;
}

@media (max-width: 768px) {
  .engage-modal-layout {
    grid-template-columns: 1fr;
  }
}

.engage-modal-step .engage-step-intro {
  font-size: 13px;
  color: #666;
  margin-bottom: 16px;
}

.engage-step-subtitle {
  font-size: 14px;
  font-weight: 600;
  margin: 8px 0 12px;
  color: #333;
}

.engage-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 500px) {
  .engage-form-row {
    grid-template-columns: 1fr;
  }
}

.engage-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.engage-modal-preview {
  background: #f8fafc;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  padding: 14px;
  position: sticky;
  top: 0;
  min-width: 0;
  overflow: hidden;
}

.engage-modal-preview h4 {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 12px;
}

.engage-preview-section {
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #eef1f5;
}

.engage-preview-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.engage-preview-section h5 {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6b7785;
  margin: 0 0 8px;
}

.engage-branded-url-box {
  margin-top: 10px;
  padding: 10px 12px;
  background: #fff;
  border: 1px dashed #c5d0e0;
  border-radius: 8px;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #4c5fd5;
  word-break: break-all;
  overflow-wrap: anywhere;
  line-height: 1.4;
  max-width: 100%;
}

.engage-preview-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
}

.engage-preview-url {
  font-size: 11px;
  color: #4c5fd5;
  margin-bottom: 10px;
}

.engage-preview-tip {
  font-size: 12px;
  color: #888;
  margin-bottom: 10px;
}

.engage-preview-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 12px;
}

.engage-preview-list li {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid #eef1f5;
  min-width: 0;
}

.engage-preview-value {
  text-align: right;
  max-width: 58%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
}

.engage-preview-value.text-break {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-all;
  text-overflow: unset;
  max-width: 65%;
}

.engage-preview-sublist {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #e8ecf1;
}

.engage-preview-list li:last-child {
  border-bottom: none;
}

.engage-preview-list .muted {
  color: #888;
}

.engage-form-group {
  margin-bottom: 18px;
}

.engage-form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #444;
  margin-bottom: 6px;
}

.engage-form-group input,
.engage-form-group select,
.engage-form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d8dee6;
  border-radius: 8px;
  font-size: 14px;
}

.engage-form-hint {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

.engage-saved-url {
  background: #f8fafc;
  border-radius: 8px;
  padding: 12px;
}

/* Table */
.engage-table-wrap .engage-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.engage-table th,
.engage-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #eef1f5;
  text-align: left;
}

.engage-table th {
  color: #6b7785;
  font-weight: 600;
  font-size: 13px;
}

.engage-type-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  background: #e6f7ee;
  color: #1b7a3f;
}

.engage-status-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  text-transform: capitalize;
}

.engage-status-pill.status-active {
  background: #e6f7ee;
  color: #1b7a3f;
}

.engage-status-pill.status-paused {
  background: #fff4e5;
  color: #9a6700;
}

.engage-status-pill.status-archived {
  background: #eef1f5;
  color: #6b7785;
}

.engage-link-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Campaign Dashboard — Inline filter bar */
.campaign-filter-bar {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
  padding: 14px 18px;
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.campaign-filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 260px;
  flex: 1 1 150px;
}

.campaign-filter-item--link {
  flex: 2 1 220px;
  min-width: 180px;
}

.campaign-filter-item label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7785;
  margin: 0;
}

.campaign-filter-item .form-control {
  height: 38px;
  font-size: 14px;
  border-color: #d8dee6;
  border-radius: 6px;
}

.campaign-filter-item--date-range {
  /* flex: 2 1 280px;
  min-width: 240px;
  max-width: 360px; */
}

.list-page-filter-accordion-body .campaign-filter-bar {
  margin-bottom: 0;
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}

.campaign-detail-section-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 8px;
  padding-top: 0;
  color: #1a2332;
}

.campaign-detail-page > .campaign-detail-section-title {
  padding-top: 14px;
}

.campaign-detail-breakdown {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.campaign-detail-breakdown-table {
  margin-block: 0;
}

.campaign-detail-bar-panel {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
  padding: 12px 14px;
  margin-bottom: 16px;
}

/* Campaign Dashboard — Summary metric cards */
.campaign-summary-grid {
  display: grid;
  gap: 12px;
  margin-bottom: 10px;
}

.campaign-summary-grid--6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.campaign-summary-grid--7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.campaign-summary-grid--5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.campaign-summary-grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.campaign-summary-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  max-width: 100%;
}

@media (max-width: 1280px) {
  .campaign-summary-grid--7 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .campaign-summary-grid--6 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .campaign-summary-grid--5 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .campaign-summary-grid--4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .campaign-summary-grid--7,
  .campaign-summary-grid--6,
  .campaign-summary-grid--5,
  .campaign-summary-grid--4,
  .campaign-summary-grid--3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .campaign-summary-grid--7,
  .campaign-summary-grid--6,
  .campaign-summary-grid--5,
  .campaign-summary-grid--4,
  .campaign-summary-grid--3 {
    grid-template-columns: 1fr;
  }
}

.campaign-summary-grid--7 .campaign-summary-card,
.campaign-summary-grid--6 .campaign-summary-card,
.campaign-summary-grid--5 .campaign-summary-card,
.campaign-summary-grid--4 .campaign-summary-card {
  min-width: 0;
}

.campaign-summary-grid--7 .campaign-summary-label,
.campaign-summary-grid--6 .campaign-summary-label,
.campaign-summary-grid--5 .campaign-summary-label,
.campaign-summary-grid--4 .campaign-summary-label {
  font-size: 10px;
  line-height: 1.35;
}

.campaign-summary-grid--7 .campaign-summary-value,
.campaign-summary-grid--6 .campaign-summary-value,
.campaign-summary-grid--5 .campaign-summary-value,
.campaign-summary-grid--4 .campaign-summary-value {
  font-size: 1.2rem;
}

/* Event metrics section — heading + per-scope (Campaign/Organic/Total) row label. */
.campaign-event-metrics-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 4px 0 10px;
  color: #1a2332;
}

.campaign-event-metrics-scope-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 6px;
}

.campaign-event-metrics-row {
  margin-bottom: 12px;
}

/* Event metrics rows — fixed 5-per-row flex layout (tile count varies with how many metrics
   an app has configured, so a fixed grid-template-columns count doesn't fit here). */
.campaign-summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 10px;
}

.campaign-summary-row .campaign-summary-card {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(20% - 9.6px);
  min-width: 150px;
}

.campaign-summary-row .campaign-summary-label {
  font-size: 10px;
  line-height: 1.35;
}

.campaign-summary-row .campaign-summary-value {
  font-size: 1.2rem;
}

@media (max-width: 1280px) {
  .campaign-summary-row .campaign-summary-card {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 8px);
  }
}

@media (max-width: 768px) {
  .campaign-summary-row .campaign-summary-card {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 6px);
  }
}

@media (max-width: 480px) {
  .campaign-summary-row .campaign-summary-card {
    flex: 1 1 100%;
  }
}

.campaign-summary-card {
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s;
  min-width: 0;
}

.campaign-summary-card:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

.campaign-summary-label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7785;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.campaign-summary-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a2332;
}

.campaign-perf-link {
  color: #1a2332;
  text-decoration: none;
}

.campaign-perf-link:hover {
  color: #4c5fd5;
  text-decoration: underline;
}

.campaign-perf-row--clickable {
  cursor: pointer;
}

.campaign-perf-row--clickable:hover {
  background: #f4f7fc;
}

.campaign-summary-link-hint {
  font-size: 11px;
  color: #4c5fd5;
  font-weight: 500;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  text-align: left;
  cursor: pointer;
  align-self: flex-start;
  font-family: inherit;
}

.campaign-summary-link-hint:hover {
  text-decoration: underline;
}

.campaign-detail-page .dashboard_heading h1 {
  margin-top: 8px;
}

.campaign-detail-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #4c5fd5;
  text-decoration: none;
  margin-bottom: 4px;
}

.campaign-detail-meta {
  font-size: 14px;
  color: #6b7785;
  margin-top: 4px;
}

.campaign-detail-meta-sep {
  margin: 0 6px;
}

.campaign-detail-tracking {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  max-width: 100%;
}

.campaign-detail-tracking code {
  font-size: 12px;
  background: #f4f6f9;
  padding: 6px 10px;
  border-radius: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.campaign-detail-source-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.campaign-detail-source-card {
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  padding: 18px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.campaign-detail-source-card h3 {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 14px;
  color: #1a2332;
}

.campaign-detail-source-totals {
  display: flex;
  gap: 24px;
  margin-bottom: 12px;
}

.campaign-detail-source-totals strong {
  display: block;
  font-size: 1.35rem;
  color: #1a2332;
}

.campaign-detail-source-totals small {
  color: #6b7785;
  font-size: 12px;
}

.campaign-detail-source-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.campaign-detail-source-label--campaign {
  color: #1b7a3f;
}

.campaign-detail-source-label--organic {
  color: #6b9e3f;
}

.campaign-detail-source-bar {
  display: flex;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  background: #eef1f5;
}

.campaign-detail-source-bar span:first-child {
  background: #1b7a3f;
}

.campaign-detail-source-bar span:last-child {
  background: #9cb86a;
}

.campaign-detail-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
  align-items: start;
}

.campaign-detail-recent-table {
  margin-bottom: 24px;
}

/* Fixed-height table areas on this page only — a long result set scrolls inside its own card
   instead of stretching the whole page (and the sticky header from .table_y_scroll stays
   useful once there's something to scroll). Scoped to .campaign-detail-page so it doesn't
   touch the many other list pages that reuse .table_inner.table_y_scroll. */
.campaign-detail-page .table_inner.table_y_scroll {
  max-height: 420px;
  overflow-y: auto;
}

@media (max-width: 900px) {
  .campaign-detail-grid-2 {
    grid-template-columns: 1fr;
  }
}

.campaign-detail-panel {
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.campaign-detail-panel--wide {
  margin-bottom: 24px;
}

.campaign-detail-panel h3 {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 12px;
  color: #1a2332;
}

.campaign-detail-empty {
  color: #6b7785;
  font-size: 13px;
  margin: 0;
}

.campaign-detail-hint {
  font-size: 12px;
  color: #6b7785;
  margin: 10px 0 0;
}

.campaign-detail-bar-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.campaign-detail-bar-list li {
  margin-bottom: 10px;
}

.campaign-detail-bar-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 4px;
}

.campaign-detail-bar-label {
  color: #333;
}

.campaign-detail-bar-value {
  font-weight: 600;
  color: #1a2332;
}

.campaign-detail-bar-value--dual {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  line-height: 1.2;
}

.campaign-detail-bar-value--dual span:last-child:not(:only-child) {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #0d6e4f;
}

.campaign-detail-bar-track {
  height: 6px;
  background: #eef1f5;
  border-radius: 3px;
  overflow: hidden;
}

.campaign-detail-bar-track span {
  display: block;
  height: 100%;
  background: #4c5fd5;
  border-radius: 3px;
  min-width: 2px;
}

.campaign-detail-bar-track--inline {
  margin-top: 4px;
  max-width: 120px;
}

.campaign-detail-dual-table {
  font-size: 13px;
}

.campaign-detail-dual-name {
  min-width: 100px;
}

.campaign-detail-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
}

.campaign-detail-badge--campaign {
  background: #e6f7ee;
  color: #1b7a3f;
}

.campaign-detail-badge--organic {
  background: #f0f4e8;
  color: #5a7a2e;
}
`, "",{"version":3,"sources":["webpack://./src/components/engage/engage.css"],"names":[],"mappings":"AAAA,iFAAiF;;;AAGjF;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,6EAA6E;EAC7E,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;;qBAEmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0FAA0F;EAC1F,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;;;;IAKE,gDAAgD;EAClD;AACF;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;AACF;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA,oFAAoF;AACpF;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;qFACqF;AACrF;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAA2B;EAA3B,cAA2B;EAA3B,6BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yCAAyC;EACzC,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;4EAG4E;AAC5E;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* Engage / OneLink — uses dashboard-box theme from App.css + Segments patterns */\n\n\n.engage-page {\n  padding: 20px 24px;\n  min-height: 100vh;\n}\n\n.engage-breadcrumb {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.engage-breadcrumb .separator {\n  margin: 0 8px;\n}\n\n.engage-breadcrumb a {\n  color: #4c5fd5;\n  text-decoration: none;\n}\n\n.engage-breadcrumb a:hover {\n  text-decoration: underline;\n}\n\n.engage-page-title {\n  font-size: 28px;\n  font-weight: 600;\n  margin: 4px 0 16px;\n  color: #1a1a1a;\n}\n\n\n.engage-template-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.engage-template-bar label {\n  font-weight: 600;\n  margin: 0;\n  color: #333;\n}\n\n.engage-template-select {\n  min-width: 160px;\n  padding: 8px 12px;\n  border: 1px solid #d8dee6;\n  border-radius: 8px;\n}\n\n.engage-template-meta {\n  font-size: 13px;\n  color: #666;\n}\n\n/* Create / edit link modal */\n.engage-create-modal .modal-body {\n  padding-top: 8px;\n  max-height: min(70vh, 640px);\n  overflow-y: auto;\n}\n\n.engage-modal-steps {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 16px;\n}\n\n.engage-modal-step-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 13px;\n  color: #666;\n  background: #f4f6f9;\n  border: 1px solid #e8ecf1;\n}\n\n.engage-modal-step-pill.active {\n  color: #4c5fd5;\n  border-color: #4c5fd5;\n  background: #eef2ff;\n  font-weight: 600;\n}\n\n.engage-modal-step-pill.done {\n  color: #1b7a3f;\n  background: #e6f7ee;\n  border-color: #b8e6c8;\n}\n\n.engage-modal-step-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  background: #fff;\n}\n\n.engage-modal-layout {\n  display: grid;\n  grid-template-columns: 1fr 240px;\n  gap: 20px;\n  align-items: start;\n  min-width: 0;\n}\n\n.engage-modal-form {\n  min-width: 0;\n}\n\n@media (max-width: 768px) {\n  .engage-modal-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.engage-modal-step .engage-step-intro {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 16px;\n}\n\n.engage-step-subtitle {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 8px 0 12px;\n  color: #333;\n}\n\n.engage-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n@media (max-width: 500px) {\n  .engage-form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.engage-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.engage-modal-preview {\n  background: #f8fafc;\n  border: 1px solid #e8ecf1;\n  border-radius: 10px;\n  padding: 14px;\n  position: sticky;\n  top: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.engage-modal-preview h4 {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 12px;\n}\n\n.engage-preview-section {\n  margin-bottom: 14px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #eef1f5;\n}\n\n.engage-preview-section:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.engage-preview-section h5 {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #6b7785;\n  margin: 0 0 8px;\n}\n\n.engage-branded-url-box {\n  margin-top: 10px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px dashed #c5d0e0;\n  border-radius: 8px;\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #4c5fd5;\n  word-break: break-all;\n  overflow-wrap: anywhere;\n  line-height: 1.4;\n  max-width: 100%;\n}\n\n.engage-preview-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n}\n\n.engage-preview-url {\n  font-size: 11px;\n  color: #4c5fd5;\n  margin-bottom: 10px;\n}\n\n.engage-preview-tip {\n  font-size: 12px;\n  color: #888;\n  margin-bottom: 10px;\n}\n\n.engage-preview-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 12px;\n}\n\n.engage-preview-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 5px 0;\n  border-bottom: 1px solid #eef1f5;\n  min-width: 0;\n}\n\n.engage-preview-value {\n  text-align: right;\n  max-width: 58%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-shrink: 1;\n  min-width: 0;\n}\n\n.engage-preview-value.text-break {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-all;\n  text-overflow: unset;\n  max-width: 65%;\n}\n\n.engage-preview-sublist {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px dashed #e8ecf1;\n}\n\n.engage-preview-list li:last-child {\n  border-bottom: none;\n}\n\n.engage-preview-list .muted {\n  color: #888;\n}\n\n.engage-form-group {\n  margin-bottom: 18px;\n}\n\n.engage-form-group label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #444;\n  margin-bottom: 6px;\n}\n\n.engage-form-group input,\n.engage-form-group select,\n.engage-form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d8dee6;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.engage-form-hint {\n  font-size: 12px;\n  color: #888;\n  margin-top: 4px;\n}\n\n.engage-saved-url {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n/* Table */\n.engage-table-wrap .engage-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.engage-table th,\n.engage-table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid #eef1f5;\n  text-align: left;\n}\n\n.engage-table th {\n  color: #6b7785;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.engage-type-pill {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  background: #e6f7ee;\n  color: #1b7a3f;\n}\n\n.engage-status-pill {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n\n.engage-status-pill.status-active {\n  background: #e6f7ee;\n  color: #1b7a3f;\n}\n\n.engage-status-pill.status-paused {\n  background: #fff4e5;\n  color: #9a6700;\n}\n\n.engage-status-pill.status-archived {\n  background: #eef1f5;\n  color: #6b7785;\n}\n\n.engage-link-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Campaign Dashboard — Inline filter bar */\n.campaign-filter-bar {\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  flex-wrap: wrap;\n  padding: 14px 18px;\n  background: #fff;\n  border: 1px solid #e8ecf1;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.campaign-filter-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 260px;\n  flex: 1 1 150px;\n}\n\n.campaign-filter-item--link {\n  flex: 2 1 220px;\n  min-width: 180px;\n}\n\n.campaign-filter-item label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7785;\n  margin: 0;\n}\n\n.campaign-filter-item .form-control {\n  height: 38px;\n  font-size: 14px;\n  border-color: #d8dee6;\n  border-radius: 6px;\n}\n\n.campaign-filter-item--date-range {\n  /* flex: 2 1 280px;\n  min-width: 240px;\n  max-width: 360px; */\n}\n\n.list-page-filter-accordion-body .campaign-filter-bar {\n  margin-bottom: 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n.campaign-detail-section-title {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0 0 8px;\n  padding-top: 0;\n  color: #1a2332;\n}\n\n.campaign-detail-page > .campaign-detail-section-title {\n  padding-top: 14px;\n}\n\n.campaign-detail-breakdown {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.campaign-detail-breakdown-table {\n  margin-block: 0;\n}\n\n.campaign-detail-bar-panel {\n  background: #fff;\n  border-radius: 0.5rem;\n  box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n  padding: 12px 14px;\n  margin-bottom: 16px;\n}\n\n/* Campaign Dashboard — Summary metric cards */\n.campaign-summary-grid {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.campaign-summary-grid--6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n\n.campaign-summary-grid--7 {\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n\n.campaign-summary-grid--5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.campaign-summary-grid--4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.campaign-summary-grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  max-width: 100%;\n}\n\n@media (max-width: 1280px) {\n  .campaign-summary-grid--7 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .campaign-summary-grid--6 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .campaign-summary-grid--5 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .campaign-summary-grid--4 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .campaign-summary-grid--7,\n  .campaign-summary-grid--6,\n  .campaign-summary-grid--5,\n  .campaign-summary-grid--4,\n  .campaign-summary-grid--3 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 480px) {\n  .campaign-summary-grid--7,\n  .campaign-summary-grid--6,\n  .campaign-summary-grid--5,\n  .campaign-summary-grid--4,\n  .campaign-summary-grid--3 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.campaign-summary-grid--7 .campaign-summary-card,\n.campaign-summary-grid--6 .campaign-summary-card,\n.campaign-summary-grid--5 .campaign-summary-card,\n.campaign-summary-grid--4 .campaign-summary-card {\n  min-width: 0;\n}\n\n.campaign-summary-grid--7 .campaign-summary-label,\n.campaign-summary-grid--6 .campaign-summary-label,\n.campaign-summary-grid--5 .campaign-summary-label,\n.campaign-summary-grid--4 .campaign-summary-label {\n  font-size: 10px;\n  line-height: 1.35;\n}\n\n.campaign-summary-grid--7 .campaign-summary-value,\n.campaign-summary-grid--6 .campaign-summary-value,\n.campaign-summary-grid--5 .campaign-summary-value,\n.campaign-summary-grid--4 .campaign-summary-value {\n  font-size: 1.2rem;\n}\n\n/* Event metrics section — heading + per-scope (Campaign/Organic/Total) row label. */\n.campaign-event-metrics-title {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 4px 0 10px;\n  color: #1a2332;\n}\n\n.campaign-event-metrics-scope-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 6px;\n}\n\n.campaign-event-metrics-row {\n  margin-bottom: 12px;\n}\n\n/* Event metrics rows — fixed 5-per-row flex layout (tile count varies with how many metrics\n   an app has configured, so a fixed grid-template-columns count doesn't fit here). */\n.campaign-summary-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.campaign-summary-row .campaign-summary-card {\n  flex: 1 1 calc(20% - 9.6px);\n  min-width: 150px;\n}\n\n.campaign-summary-row .campaign-summary-label {\n  font-size: 10px;\n  line-height: 1.35;\n}\n\n.campaign-summary-row .campaign-summary-value {\n  font-size: 1.2rem;\n}\n\n@media (max-width: 1280px) {\n  .campaign-summary-row .campaign-summary-card {\n    flex: 1 1 calc(33.333% - 8px);\n  }\n}\n\n@media (max-width: 768px) {\n  .campaign-summary-row .campaign-summary-card {\n    flex: 1 1 calc(50% - 6px);\n  }\n}\n\n@media (max-width: 480px) {\n  .campaign-summary-row .campaign-summary-card {\n    flex: 1 1 100%;\n  }\n}\n\n.campaign-summary-card {\n  background: #fff;\n  border: 1px solid #e8ecf1;\n  border-radius: 10px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s;\n  min-width: 0;\n}\n\n.campaign-summary-card:hover {\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);\n}\n\n.campaign-summary-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7785;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.campaign-summary-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1a2332;\n}\n\n.campaign-perf-link {\n  color: #1a2332;\n  text-decoration: none;\n}\n\n.campaign-perf-link:hover {\n  color: #4c5fd5;\n  text-decoration: underline;\n}\n\n.campaign-perf-row--clickable {\n  cursor: pointer;\n}\n\n.campaign-perf-row--clickable:hover {\n  background: #f4f7fc;\n}\n\n.campaign-summary-link-hint {\n  font-size: 11px;\n  color: #4c5fd5;\n  font-weight: 500;\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  cursor: pointer;\n  align-self: flex-start;\n  font-family: inherit;\n}\n\n.campaign-summary-link-hint:hover {\n  text-decoration: underline;\n}\n\n.campaign-detail-page .dashboard_heading h1 {\n  margin-top: 8px;\n}\n\n.campaign-detail-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: #4c5fd5;\n  text-decoration: none;\n  margin-bottom: 4px;\n}\n\n.campaign-detail-meta {\n  font-size: 14px;\n  color: #6b7785;\n  margin-top: 4px;\n}\n\n.campaign-detail-meta-sep {\n  margin: 0 6px;\n}\n\n.campaign-detail-tracking {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  max-width: 100%;\n}\n\n.campaign-detail-tracking code {\n  font-size: 12px;\n  background: #f4f6f9;\n  padding: 6px 10px;\n  border-radius: 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.campaign-detail-source-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.campaign-detail-source-card {\n  background: #fff;\n  border: 1px solid #e8ecf1;\n  border-radius: 10px;\n  padding: 18px 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.campaign-detail-source-card h3 {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 14px;\n  color: #1a2332;\n}\n\n.campaign-detail-source-totals {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 12px;\n}\n\n.campaign-detail-source-totals strong {\n  display: block;\n  font-size: 1.35rem;\n  color: #1a2332;\n}\n\n.campaign-detail-source-totals small {\n  color: #6b7785;\n  font-size: 12px;\n}\n\n.campaign-detail-source-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.campaign-detail-source-label--campaign {\n  color: #1b7a3f;\n}\n\n.campaign-detail-source-label--organic {\n  color: #6b9e3f;\n}\n\n.campaign-detail-source-bar {\n  display: flex;\n  height: 8px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #eef1f5;\n}\n\n.campaign-detail-source-bar span:first-child {\n  background: #1b7a3f;\n}\n\n.campaign-detail-source-bar span:last-child {\n  background: #9cb86a;\n}\n\n.campaign-detail-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n  align-items: start;\n}\n\n.campaign-detail-recent-table {\n  margin-bottom: 24px;\n}\n\n/* Fixed-height table areas on this page only — a long result set scrolls inside its own card\n   instead of stretching the whole page (and the sticky header from .table_y_scroll stays\n   useful once there's something to scroll). Scoped to .campaign-detail-page so it doesn't\n   touch the many other list pages that reuse .table_inner.table_y_scroll. */\n.campaign-detail-page .table_inner.table_y_scroll {\n  max-height: 420px;\n  overflow-y: auto;\n}\n\n@media (max-width: 900px) {\n  .campaign-detail-grid-2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.campaign-detail-panel {\n  background: #fff;\n  border: 1px solid #e8ecf1;\n  border-radius: 10px;\n  padding: 16px 18px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.campaign-detail-panel--wide {\n  margin-bottom: 24px;\n}\n\n.campaign-detail-panel h3 {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 12px;\n  color: #1a2332;\n}\n\n.campaign-detail-empty {\n  color: #6b7785;\n  font-size: 13px;\n  margin: 0;\n}\n\n.campaign-detail-hint {\n  font-size: 12px;\n  color: #6b7785;\n  margin: 10px 0 0;\n}\n\n.campaign-detail-bar-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.campaign-detail-bar-list li {\n  margin-bottom: 10px;\n}\n\n.campaign-detail-bar-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n\n.campaign-detail-bar-label {\n  color: #333;\n}\n\n.campaign-detail-bar-value {\n  font-weight: 600;\n  color: #1a2332;\n}\n\n.campaign-detail-bar-value--dual {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  line-height: 1.2;\n}\n\n.campaign-detail-bar-value--dual span:last-child:not(:only-child) {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #0d6e4f;\n}\n\n.campaign-detail-bar-track {\n  height: 6px;\n  background: #eef1f5;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.campaign-detail-bar-track span {\n  display: block;\n  height: 100%;\n  background: #4c5fd5;\n  border-radius: 3px;\n  min-width: 2px;\n}\n\n.campaign-detail-bar-track--inline {\n  margin-top: 4px;\n  max-width: 120px;\n}\n\n.campaign-detail-dual-table {\n  font-size: 13px;\n}\n\n.campaign-detail-dual-name {\n  min-width: 100px;\n}\n\n.campaign-detail-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.campaign-detail-badge--campaign {\n  background: #e6f7ee;\n  color: #1b7a3f;\n}\n\n.campaign-detail-badge--organic {\n  background: #f0f4e8;\n  color: #5a7a2e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
